// extracted by mini-css-extract-plugin
export var displayNone = "_pe-6";
export var imgContainer = "_pe-2";
export var overflowHidden = "_pe-3";
export var productInfoCardButtonContainer = "_pe-5";
export var productTitleText = "_pe-4";
export var rightArrow = "_pe-1";
export var rightArrowContainer = "_pe-0";